import { render } from "./Sus.vue?vue&type=template&id=77785a3d&scoped=true"
import script from "./Sus.vue?vue&type=script&lang=js"
export * from "./Sus.vue?vue&type=script&lang=js"

import "./Sus.vue?vue&type=style&index=0&id=77785a3d&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77785a3d"]])

export default __exports__